var _path, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayWithCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4209 22.841L15.5232 33.1743L15.5232 12.5077L33.4209 22.841Z",
    fill: "url(#paint0_linear_302_338)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5117,
    cy: 22.5,
    r: 22,
    stroke: "url(#paint1_linear_302_338)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_302_338",
    x1: 21.83,
    y1: 16.0228,
    x2: 29.652,
    y2: 23.3186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8AC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2E7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_302_338",
    x1: 22.5116,
    y1: 0.000166823,
    x2: 44.957,
    y2: 20.9356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8AC77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2E7FE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayWithCircle);
export default __webpack_public_path__ + "static/media/play_with_circle.f7decfd06bd059c84fa482524ecc84a4.svg";
export { ForwardRef as ReactComponent };